module.exports = require('./_global');


//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706012359-95877d6b9a-master/~/core-js/modules/_path.js
// module id = 629
// module chunks = 1